import { getLoadList as getLoadListApi } from '@/api/load-boards'
import cloneDeep from 'lodash/cloneDeep'

const store = {
  namespaced: true,
  state: {
    loadAllList: [],
    loadCurrentList: [],
    loadTotal: 0,
    loadCurrentPage: 1,
    loadPageSize: 20,
    searchQuery: {}, // 搜索页面表格的搜索条件
    loadSearchSort: [], // 搜索页面表格的排序
    searchCriteria: null, // 搜索页面记录的表单信息
    searchShowTable: false, // 搜索页面是否展示表格
  },
  mutations: {
    SET_LOAD_ALL_LIST(state, list) {
      state.loadAllList = list
    },
    SET_LOAD_CURRENT_LIST(state, list) {
      state.loadCurrentList = list
    },
    SET_LOAD_TOTAL(state, total) {
      state.loadTotal = total
    },
    SET_LOAD_CURRENT_PAGE(state, page) {
      state.loadCurrentPage = page
    },
    SET_SEARCH_QUERY(state, query) {
      state.searchQuery = query
    },
    SET_LOAD_SEARCH_SORT(state, sort) {
      state.loadSearchSort = sort
    },
    SET_SEARCHFORM(state, form) {
      if (form) {
        state.searchCriteria = cloneDeep(form);
      } else {
        state.searchCriteria = null;
      }
    },
    SET_SEARCH_SHOW_TABLE(state, status) {
      state.searchShowTable = status
    },
    SET_LOAD_PAGE_SIZE(state, size) {
      state.loadPageSize = size
    },
    UPDATE_LOAD_INFO(state, load) {
      let loadIndex = state.loadAllList.findIndex(item => item.id === load.id)
      if (loadIndex > -1) {
        state.loadAllList[loadIndex] = Object.assign(state.loadAllList[loadIndex], load)
        state.loadCurrentList = state.loadAllList.slice((state.loadCurrentPage - 1) * state.loadPageSize, state.loadCurrentPage * state.loadPageSize)
      }
    }
  },
  actions: {
    updatePageSize({ commit } , size) {
      commit('SET_LOAD_PAGE_SIZE', size)
    },
    updateLoadCurrentPage({ commit }, currentPage) {
      commit('SET_LOAD_CURRENT_PAGE', currentPage)
    },
    updateSearchQuery({ commit }, query) {
      commit('SET_SEARCH_QUERY', query)
    },
    updateLoadSearchSort({ commit }, sort) {
      commit('SET_LOAD_SEARCH_SORT', sort)
    },
    updateSearchShowTable({ commit }, status) {
      commit('SET_SEARCH_SHOW_TABLE', status)
    },
    getLoadList({ commit, state }) {
      let data = {
        page: state.loadCurrentPage,
        size: state.loadPageSize,
        query: state.searchQuery,
        sort: state.loadSearchSort.map(item => ({ [item.field]: item.order }))
      }
      return getLoadListApi(1, data).then(res => {
        let page = state.loadCurrentPage
        let size = state.loadPageSize
        commit('SET_LOAD_ALL_LIST', res.data)
        commit('SET_LOAD_CURRENT_LIST', res.data.slice((page - 1) * size, page * size))
        commit('SET_LOAD_TOTAL', res.data.length)
        return res
      })
    },
    initLoadList({ commit }) {
      commit('SET_LOAD_ALL_LIST', [])
      commit('SET_LOAD_CURRENT_LIST', [])
      commit('SET_LOAD_TOTAL', 0)
      commit('SET_LOAD_CURRENT_PAGE', 1)
    },
    getCurrentPageList({ commit, state }, page) {
      let size = state.loadPageSize
      commit('SET_LOAD_CURRENT_PAGE', page)
      commit('SET_LOAD_CURRENT_LIST', state.loadAllList.slice((page - 1) * size, page * size))
    },
    updateLoad({ commit }, load) {
      commit('UPDATE_LOAD_INFO', load)
    }
  }
}

export default store